function pickEventString(
    event: Record<string, unknown>,
    camelKey: string,
    pascalKey: string
): string | undefined {
    const raw = event[camelKey] ?? event[pascalKey];
    return typeof raw === 'string' && raw.trim() !== '' ? raw : undefined;
}

/** Human-readable stage line from `E335v1_UnitCreationProgress`. */
export function parseUnitCreationProgressLabel(
    event: Record<string, unknown> | null | undefined
): string | null {
    if (!event) return null;
    return (
        pickEventString(event, 'e335_Label', 'E335_Label') ??
        pickEventString(event, 'e335_StageKey', 'E335_StageKey') ??
        null
    );
}
